import { useState, useEffect } from 'react';
import { useOrderStore } from '../../store/useOrder';

/**
 * @author taulmax
 * @date 2024.12.02
 * @description 로딩 UI
 */
const Loading = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length < 6 ? prev + '.' : ''));
    }, 1000); // 0.5초마다 업데이트

    return () => clearInterval(interval); // 컴포넌트 언마운트 시 정리
  }, []);

  const {
    postOrderLoading,
    updateOrderLoading,
    deleteOrderLoading,
    confirmOrderLoading,
    updatePromptProcessLoading,
    makePDFMySelfLoading,
    retryContractPromptLoading,
    sendPDFLoading,
  } = useOrderStore();
  const isLoading =
    postOrderLoading ||
    updateOrderLoading ||
    deleteOrderLoading ||
    confirmOrderLoading ||
    updatePromptProcessLoading ||
    makePDFMySelfLoading ||
    retryContractPromptLoading ||
    sendPDFLoading;

  if (!isLoading) {
    return null; // 로딩이 없으면 아무것도 렌더링하지 않음
  }

  return (
    <div className="loading_ui_wrapper">
      <div className="loading_img"></div>
      <p style={{ marginTop: '20px' }}>
        잠시만 기다려주세요{dots}
      </p>
    </div>
  );
};

export default Loading;
